import { createBrowserRouter, Navigate } from 'react-router-dom';
import { AppLayout } from './AppLayout';
import { ProtectedRoute } from './ProtectedRoute';
import { LoginPage } from '../modules/auth/LoginPage';
import { DashboardPage } from '../modules/dashboard/DashboardPage';
import { PdvPage } from '../modules/pdv/PdvPage';
import { VendasPage } from '../modules/vendas/VendasPage';
import { CaixaPage } from '../modules/caixa/CaixaPage';
import { ComandasPage } from '../modules/comandas/ComandasPage';
import { ProdutosPage } from '../modules/produtos/ProdutosPage';
import { RelatoriosPage } from '../modules/relatorios/RelatoriosPage';

export const router = createBrowserRouter([
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/',
    element: (
      <ProtectedRoute>
        <AppLayout />
      </ProtectedRoute>
    ),
    children: [
      { index: true, element: <Navigate to="/dashboard" replace /> },
      { path: 'dashboard', element: <DashboardPage /> },
      { path: 'pdv', element: <PdvPage /> },
      { path: 'vendas', element: <VendasPage /> },
      { path: 'comandas', element: <ComandasPage /> },
      { path: 'caixa', element: <CaixaPage /> },
      { path: 'produtos', element: <ProdutosPage /> },
      { path: 'relatorios', element: <RelatoriosPage /> },
    ],
  },
  {
    path: '*',
    element: <Navigate to="/" replace />,
  },
]);
